import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import firebase from 'firebase/compat/app'
import VueCarousel from 'vue-carousel'
import '@/scss/styles.scss'
import ReadMore from 'vue-read-more'
import responsive from 'vue-responsive'
import BvueUi from '@bvapps/bvue-ui'
import { DynamicScroller } from 'vue-virtual-scroller'
import VueAnalytics from 'vue-analytics'
import Vuex from 'vuex'
import { analytics, facebook, brightcove } from './config'
import VueMeta from 'vue-meta'

console.log(facebook)

// import firebase from 'firebase/compat/app'

// import 'firebase/compat/firestore'
// import 'firebase/compat/storage'
// import 'firebase/compat/auth'
// import 'firebase/compat/functions'

Vue.use(VueAnalytics, {
  id: analytics
})

Vue.component('DynamicScroller', DynamicScroller)

Vue.use(BvueUi)

Vue.use(responsive)
Vue.use(ReadMore)
Vue.use(VueCarousel)
Vue.use(VueMeta)
Vue.config.productionTip = false

function render() {
  const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
  Vuex.Store.prototype.$vue = app
}

function initFacebookSdk() {
  window.fbAsyncInit = function () {
    FB.init({
      appId: facebook[process.env.VUE_APP_ID === 'microcanales-cne-df069' ? 'hun' : 'cz'].appId,
      cookie: true,
      xfbml: true,
      version: 'v13.0'
    });
    FB.AppEvents.logPageView();
  };

  // load facebook sdk script
  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
}

function initConsentNotice() {


  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    js.dataset.documentLanguage="true";
    js.type="text/javascript";
    js.charset="UTF-8";
    js.dataset.domainScript="a7f3d076-7c78-4c00-8176-5b031bff8d47-test";
    fjs.parentNode.insertBefore(js, fjs);
    window.OptanonWrapper = function() {};
  }(document, 'script', 'consent-notice'));
}

function initBrightCove() {
  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = `//players.brightcove.net/${brightcove[process.env.VUE_APP_ID === 'microcanales-cne-df069' ? 'hun' : 'cz'].accountId}/default_default/index.min.js`;
    js.type="text/javascript";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'brightcove-player'));
}

const userLocal = store.getters.user
if (userLocal) {
  store.dispatch('autoSignIn', userLocal || null)
  store.dispatch('getUserData', userLocal || null)
  .then(() => {
    store.dispatch('myList', userLocal || null)
    store.dispatch('getWatching', userLocal || null)    
  })
}
initFacebookSdk()
initBrightCove()
render()
initConsentNotice()

const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
  window.onLoad()
  user && store.dispatch('getUserData', user || userLocal || null)
  if (!user && userLocal) {
    store.dispatch('autoSignIn', null)
    render()
  }
})
